<template>
  <footer class="footer">
    <TheNewsletter></TheNewsletter>
    <div class="footer__address">
      <p>Iivaara Wilderness Lodge</p>
      <p>Hiltusentie 144</p>
      <p>Kuusamo (93999)</p>
      <p>Finland</p>
      <p><a href="mailto:info@iivaaralodge.com">info@iivaaralodge.com</a></p>
      <p>
        <a target="_blank" href="https://www.facebook.com/IivaaraWildernessLodge">
          <fa-icon :icon="['fab','facebook-f']"></fa-icon>
        </a>
      </p>
      <img src="../assets/img/icon.png" alt="icon Iivaara Wilderness Lodge">
    </div>
  </footer>
</template>

<script>
import TheNewsletter from "@/components/TheNewsletter";
export default {
  name: "TheFooter",
  components: {
    TheNewsletter
  }
}
</script>